import request from "@/plugin/axios";
import axios from "axios";
import util from "@/libs/util";
const token = util.cookies.get("token");


export function getFileInfo(data){
    return request({
        url: '/api/case/czCaseFiles/fileList',
        method: 'get',
        params:data
    })
}

export function bindCase(data){
    return request({
        url: '/api/case/czCaseFiles/batchBindingCase',
        method: 'post',
        data:data
    })
}

export function batchDeleteFile(data){
    return request({
        url: '/api/case/czCaseFiles/batchDeleteFile',
        method: 'post',
        data:data
    })
}

export function putObj(id, obj) {
    return request({
    url: '/api/case/czCaseFiles/' + id,
    method: 'put',
    data: obj
    })
}